export class Preferences {
  constructor(public termCurrency: string, public selectedMarket: string, public showZeroBalances: boolean, public chartSettings: any) {}
}
